import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import RidGenerator from 'utils/swarm/rid-generator';
import { WebsocketEnhanced } from 'interfaces/spring-websocket-interfaces';
import { connectingWS } from 'hooks/useSpringConnect';

export const getTournaments = (
  params: object,
  callback: Function,
  errorCallback: Function | null = null
): void => {
  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(
      {
        command: CommandNames.GET_TOURNAMENT_LIST,
        params,
        rid: RidGenerator.gForCommand()
      },
      '',
      callback,
      null,
      errorCallback
    );
  });
};

export const getTournament = (id: number, callback: Function): void => {
  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(
      {
        command: CommandNames.GET_TOURNAMENT,
        params: {
          tournament_id: id
        },
        rid: RidGenerator.gForCommand()
      },
      '',
      callback
    );
  });
};

export const getTournamentStats = (id: number, callback: Function): void => {
  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(
      {
        command: CommandNames.GET_TOURNAMENT_STATS,
        params: {
          tournament_id: id
        },
        rid: RidGenerator.gForCommand()
      },
      '',
      callback
    );
  });
};

export const joinTournament = (
  tournamentId: number,
  callback: Function,
  errorCallback?: () => void
): void => {
  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(
      {
        command: CommandNames.JOIN_TO_TOURNAMENT,
        params: {
          tournament_id: tournamentId
        },
        rid: RidGenerator.gForCommand()
      },
      '',
      callback,
      null,
      errorCallback
    );
  });
};
